<template>
  <div>
    <el-divider> Training Information </el-divider>
    <el-row class="select-date">
      <el-col :span="24">
        <el-form :model="training" ref="trainingForm" :rules="trainingRules">
          <el-form-item
            prop="dateTime"
            class="tw-text-sm tw-font-normal tw-leading-4 tw-text-black"
            label="Training Date"
          >
            <input
              type="date"
              class="input"
              v-model="tempDate"
              :class="tempDate ? 'tw-font-medium' : 'tw-font-normal'"
            />
          </el-form-item>
          <el-form-item
            prop="endTime"
            class="tw-text-sm tw-font-normal tw-leading-4 tw-text-black"
            label="Training End Time"
          >
            <input
              class="input"
              type="time"
              v-model="tempTime"
              :class="tempTime ? 'tw-font-medium' : 'tw-font-normal'"
            />
          </el-form-item>
          <el-form-item
            prop="venue"
            label="Venue"
            class="tw-text-sm tw-font-normal tw-leading-4 tw-text-black"
          >
            <div
              id="suggestions"
              v-if="searchVenue"
              class="tw-pr-1 tw-border-b-2 tw-border-gray-200"
            >
              <input
                class="search tw-py-1"
                :class="trainingVenue ? 'tw-font-medium tw-text-black' : 'tw-font-normal '"
                v-model="trainingVenue"
                placeholder="Search venue"
                @keyup="suggest"
                autocomplete="on"
              />

              <div
                class="tw-p-2 tw-text-xs tw-bg-gray-200"
                v-for="venueSuggestion of allVenues"
                :key="venueSuggestion._id"
                @click="selectVenue(venueSuggestion)"
              >
                {{ venueSuggestion.name }}
              </div>
            </div>

            <input
              v-else
              class="input"
              v-model="trainingVenue"
              placeholder="Enter a venue"
              required
            />
          </el-form-item>

          <div
            @click="searchVenue = !searchVenue"
            class="tw-text-sm tw-font-normal tw-leading-4 tw-text-black tw-underline tw-mb-4"
            :class="searchVenue ? 'tw-mt-5' : ''"
          >
            {{ searchVenue ? "Manually enter a venue" : "Find a venue" }}
          </div>

          <label
            v-if="clearance === roles.programAdmin || clearance === roles.clubProgramAdmin"
            class="tw-mt-5"
          >
            Program
            <select
              name="trainingProgram"
              id="trainingProgram"
              v-model="programId"
              required
              :class="
                programId !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select a program</option>
              <option
                v-for="({ name, _id }, index) in programs"
                :key="index"
                :value="_id"
                :label="name"
              >
                {{ name }}
              </option>
            </select>
          </label>

          <label
            v-if="clearance === roles.programAdmin || clearance === roles.clubProgramAdmin"
            class="tw-mt-5"
            >Session No.

            <input
              class="input"
              type="number"
              :controls="false"
              :precision="0"
              :min="0"
              v-model="trainingMetaSessionNo"
            />
          </label>
          <!-- <h4 class="tw-mt-5 tw-text-sm tw-font-normal tw-leading-4 tw-text-black">
            In the previous 14 days have any of the attendees
          </h4> -->
          <!-- <CheckBoxLine
            v-model="trainingCovidSymptoms"
            class="tw-pb-2 tw-mt-5 tw-text-sm tw-font-normal tw-leading-4 tw-text-black"
          >
            Had any COVID-19 symptoms?
          </CheckBoxLine> -->
          <!-- <div v-if="trainingCovidSymptoms">
            <input
              class="input "
              placeholder="Please provide more information"
              v-model="trainingCovidSymptomsNotes"
            />
          </div> -->
          <!-- <CheckBoxLine
            v-model="trainingCovidContact"
            class="tw-pb-2 tw-mt-5 tw-text-sm tw-font-normal tw-leading-4 tw-text-black"
          >
            Been in contact with any confirmed/suspected COVID-19 case?
          </CheckBoxLine> -->
          <!-- <div v-if="trainingCovidContact">
            <input
              class="input"
              placeholder="Please provide more information"
              v-model="trainingCovidContactNotes"
            />
          </div> -->
          <!-- <CheckBoxLine
            v-model="trainingTravelHas"
            class="tw-pb-2 tw-mt-5 tw-text-sm tw-font-normal tw-leading-4 tw-text-black"
          >
            Travelled internationally, attended an identified COVID-19 case location, or an area
            where your state government has determined restrictions apply
            <a href="https://www.playrugbyleague.com/stategovernmentcovidresources/" target="_blank"
              >(see state government links for information on locally acquired cases and directions
              in place).</a
            >
          </CheckBoxLine> -->
          <!-- <div v-if="trainingTravelHas">
            <input
              class=" input"
              placeholder="Please provide more information"
              v-model="trainingTravelNotes"
            />
          </div> -->
          <el-form-item
            prop="notes"
            class="tw-text-sm tw-font-normal tw-leading-4 tw-text-black tw--mb-2px"
            label="Notes"
          >
            <textarea
              id="notes"
              rows="3"
              cols="50"
              maxlength="300"
              v-model="notes"
              :class="notes ? 'tw-font-medium ' : 'tw-font-normal '"
            ></textarea>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <div class="tw-grid tw-grid-flow-col tw-grid-rows-2 tw-gap-0 tw-my-6">
      <div class="tw-row-start-2 tw-row-end-2 tw-border-t"></div>
      <div class="tw-row-span-2 tw-text-sm tw-font-medium tw-leading-5 tw-text-center tw-bg-white">
        Training Attendees
      </div>
      <div class="tw-row-start-2 tw-row-end-2 tw-border-t"></div>
    </div>

    <div class="tw-flex tw-justify-center tw-mt-2 tw-mb-9">
      <div class="tw-flex tw-text-xs">
        <input class="tw-hidden" id="players" type="radio" v-model="isPlayerScreen" :value="true" />
        <label
          class="tw-h-8 tw-py-2 tw-text-center tw-rounded-l-lg tw-w-28 hover:tw-bg-green-300 hover:tw-text-black"
          :class="{
            'tw-bg-green-700 tw-text-white': isPlayerScreen,
            'tw-bg-white tw-text-gray-400 tw-border tw-border-gray-200': !isPlayerScreen,
            'tw-rounded-r':
              clearance === roles.programAdmin || clearance === roles.clubProgramAdmin,
          }"
          for="players"
          >Players</label
        >
        <input
          class="tw-hidden"
          id="officials"
          type="radio"
          v-model="isPlayerScreen"
          v-if="clearance !== roles.programAdmin"
          :value="false"
        />
        <label
          class="tw-h-8 tw-py-2 tw-text-center tw-rounded-r-lg tw-w-28 hover:tw-bg-green-300 hover:tw-text-black"
          :class="{
            'tw-bg-green-700 tw-text-white': !isPlayerScreen,
            'tw-bg-white tw-text-gray-400 tw-border tw-border-gray-200': isPlayerScreen,
          }"
          v-if="clearance !== roles.programAdmin"
          for="officials"
          >Officials</label
        >
      </div>
    </div>

    <!-- Players Screen -->
    <div v-show="isPlayerScreen">
      <div class="tw-mb-9">
        <div class="tw-flex tw-justify-center">
          <button
            type="secondary"
            class="tw-justify-center tw-w-full tw-mb-4 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-gray-200 tw-border-2 tw-border-green-700 sm:tw-w-5/6 hover:tw-border-gray-200 4"
            @click="showSelectPlayers = true"
          >
            Add Players
          </button>
        </div>
        <div class="tw-flex tw-justify-center">
          <button
            type="secondary"
            class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-gray-200 tw-border-2 tw-border-green-700 sm:tw-w-5/6 hover:tw-border-gray-200 4"
            @click="
              addMemberDialog = true;
              currentManualType = 'player';
            "
          >
            New Member
          </button>
        </div>
      </div>

      <div class="tw-w-full tw-p-0 tw-px-2 tw-py-2 tw-pb-5 tw-m-0 tw-bg-white">
        <div class="tw-grid tw-grid-cols-2 tw-gap-auto tw-mb-2.5">
          <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">NAME</div>
          <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">ACTIONS</div>
        </div>
        <div
          class="tw-grid tw-grid-cols-2 tw-mb-3 tw-gap-auto"
          v-for="player in trainingPlayers"
          :key="player._id"
        >
          <div
            v-if="player.firstName && player.lastName"
            class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left"
          >
            <div>{{ player.firstName }}</div>
            <div>{{ player.lastName.toUpperCase() }}</div>
          </div>
          <div v-else class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">{{ "N/A" }}</div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-w-5 tw-h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="removePlayer(player)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>
        </div>
      </div>

      <h4 class="tw-mb-3 tw-text-sm tw-leading-4 tw-text-black tw-mt-9 tw-font-base">
        Manual Players
      </h4>

      <div class="tw-w-full tw-p-0 tw-px-2 tw-py-2 tw-pb-5 tw-m-0 tw-bg-white">
        <div class="tw-grid tw-grid-cols-4 tw-gap-5 tw-mb-2.5">
          <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">NAME</div>
          <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">MOBILE</div>
          <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">EMAIL</div>
          <div class="tw-flex-1 tw-w-1/4 tw-text-xs tw-font-medium tw-text-black">ACTIONS</div>
        </div>
        <div
          class="tw-grid tw-grid-cols-4 tw-gap-5 tw-mb-3"
          v-for="manualPlayer in trainingManualPlayers"
          :key="manualPlayer._id"
        >
          <div
            v-if="manualPlayer.firstName && manualPlayer.lastName"
            class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left"
          >
            <div>{{ manualPlayer.firstName }}</div>
            <div>{{ manualPlayer.lastName.toUpperCase() }}</div>
          </div>
          <div v-else class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">{{ "N/A" }}</div>
          <div
            v-if="manualPlayer.mobile"
            class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left"
          >
            <div>{{ manualPlayer.mobile }}</div>
          </div>
          <div v-else class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">{{ "N/A" }}</div>
          <div
            v-if="manualPlayer.email"
            class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left"
          >
            <div>{{ manualPlayer.email }}</div>
          </div>
          <div v-else class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">{{ "N/A" }}</div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-w-5 tw-h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="removePlayer(manualPlayer, 'manual')"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Team Officials Screen  -->
    <div v-show="!isPlayerScreen" v-if="clearance !== roles.programAdmin">
      <div class="modal-select">
        <button
          type="secondary"
          class="tw-justify-center tw-w-full tw-mb-4 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-gray-200 tw-border-2 tw-border-green-700 sm:tw-w-5/6 hover:tw-border-gray-200"
          @click="showSelectNonPlayers = true"
        >
          Add Officials
        </button>
        <button
          type="secondary"
          class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-gray-200 tw-border-2 tw-border-green-700 sm:tw-w-5/6 hover:tw-border-gray-200"
          @click="
            addMemberDialog = true;
            currentManualType = 'nonplayer';
          "
        >
          New Member
        </button>
      </div>

      <div class="tw-w-full tw-p-0 tw-px-2 tw-py-2 tw-pb-5 tw-m-0 tw-bg-white">
        <div class="tw-grid tw-grid-cols-2 tw-gap-auto tw-mb-2.5">
          <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">NAME</div>
          <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">ACTIONS</div>
        </div>
        <div
          class="tw-grid tw-grid-cols-2 tw-mb-3 tw-gap-auto"
          v-for="nonplayer in trainingNonPlayers"
          :key="nonplayer._id"
        >
          <div
            v-if="nonplayer.firstName && nonplayer.lastName"
            class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left"
          >
            <div>{{ nonplayer.firstName }}</div>
            <div>{{ nonplayer.lastName.toUpperCase() }}</div>
          </div>
          <div v-else class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">{{ "N/A" }}</div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-w-5 tw-h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="removePlayer(nonplayer)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>
        </div>
      </div>
      <h4 class="tw-mb-3 tw-text-sm tw-leading-4 tw-text-black tw-mt-9 tw-font-base">
        Manual Non-Players
      </h4>

      <div class="tw-w-full tw-p-0 tw-px-2 tw-py-2 tw-pb-5 tw-m-0 tw-bg-white">
        <div class="tw-grid tw-grid-cols-2 tw-gap-auto tw-mb-2.5">
          <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">NAME</div>
          <div class="tw-flex-1 tw-text-xs tw-font-medium tw-text-black">ACTIONS</div>
        </div>
        <div
          class="tw-grid tw-grid-cols-2 tw-mb-3 tw-gap-auto"
          v-for="manualNonPlayers in trainingManualNonPlayers"
          :key="manualNonPlayers._id"
        >
          <div
            v-if="manualNonPlayers.firstName && manualNonPlayers.lastName"
            class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left"
          >
            <div>{{ manualNonPlayers.firstName }}</div>
            <div>{{ manualNonPlayers.lastName.toUpperCase() }}</div>
          </div>
          <div v-else class="tw-text-xs tw-font-normal tw-leading-3 tw-text-left">{{ "N/A" }}</div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-w-5 tw-h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="removePlayer(manualNonPlayers, 'manual')"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-mt-2.5">
      <div class="tw-flex tw-justify-center">
        <button
          v-if="isEdit()"
          type="danger"
          class="tw-justify-center tw-mb-4 sm:tw-w-5/6 tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-gray-200 tw-border-2 tw-border-green-700 hover:tw-border-gray-200"
          @click="deleteTrainingList"
        >
          Delete
        </button>
      </div>
      <div class="tw-flex tw-justify-center">
        <button
          type="submit"
          class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 sm:tw-w-5/6 hover:tw-bg-green-300 hover:tw-text-black"
          @click="submitTrainingList"
        >
          Submit
        </button>
      </div>
    </div>

    <el-dialog
      width="80%"
      @close="selectedPlayers = []"
      :visible.sync="showSelectPlayers"
      title="Select Players"
    >
      <div class="player-list" v-if="availablePlayersToAdd.length">
        <button class="btn-success" size="small" type="success" @click="addPlayers">Confirm</button>
        <button class="btn-selectAll" @click="selectAllPlayers">
          {{ selectedPlayers.length ? "Unselect All" : "Select All" }}
        </button>
        <ul class="list-group list-group-flush">
          <li
            class="list-group-item fadeIn"
            v-for="member in availablePlayersToAdd"
            :key="member._id"
          >
            <div class="tw-inline-block tw-float-none tw-text-left tw-w-5/6">
              <input
                class="my-checkbox"
                type="checkbox"
                :value="member._id"
                :name="member._id"
                :id="member._id"
                v-model="selectedPlayers"
              />
              <label :for="member._id" class="tw-flex">
                {{ member.profile.firstName }} {{ member.profile.lastName }}</label
              >
            </div>
            <div class="tw-inline-block tw-w-1/6">
              <br />
              <label class="text-center">
                <i
                  class="el-icon-check custom-icon fadeIn"
                  :id="`icon_${member._id}`"
                  v-if="selectedPlayers.includes(member._id)"
              /></label>
            </div>
          </li>
        </ul>
      </div>
      <h4 class="text-center" v-else>No more players to add.</h4>
    </el-dialog>

    <el-dialog
      v-if="clearance !== roles.programAdmin"
      width="80%"
      @close="selectedNonPlayers = []"
      :visible.sync="showSelectNonPlayers"
      title="Select Officials"
    >
      <div class="player-list">
        <select
          v-model="roleFilter"
          :class="
            roleFilter !== undefined
              ? 'tw-font-medium tw-text-black'
              : 'tw-font-normal tw-text-black'
          "
        >
          <option disabled :value="undefined" selected="selected">Select Role</option>
          <option v-for="{ type, name } in nonPlayerRoles" :key="type" :label="name" :value="type">
            {{ name }}
          </option>
        </select>
        <div v-if="availableNonPlayersToAdd.length" class="player-list-wrapper">
          <button class="btn-success" size="small" type="success" @click="addNonPlayers">
            Confirm
          </button>
          <button class="btn-selectAll" @click="selectAllNonPlayers">
            {{ selectedNonPlayers.length ? "Unselect All" : "Select All" }}
          </button>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item fadeIn"
              v-for="member in availableNonPlayersToAdd"
              :key="member._id"
            >
              <div class="tw-inline-block tw-float-none tw-text-left tw-w-5/6">
                <input
                  class="my-checkbox"
                  type="checkbox"
                  :value="member._id"
                  :name="member._id"
                  :id="member._id"
                  v-model="selectedNonPlayers"
                />
                <label :for="member._id" class="tw-flex">
                  {{ member.profile.firstName }} {{ member.profile.lastName }}</label
                >
              </div>
              <div class="tw-inline-block tw-w-1/6">
                <br />
                <label class="text-center">
                  <i
                    class="el-icon-check custom-icon fadeIn"
                    :id="`icon_${member._id}`"
                    v-if="selectedNonPlayers.includes(member._id)"
                /></label>
              </div>
            </li>
          </ul>
        </div>
        <h4 class="text-center tw-mt-2.5" v-else>No more players to add.</h4>
      </div>
    </el-dialog>

    <el-dialog width="80%" title="Manually Add A Member" :visible.sync="addMemberDialog">
      <el-form :model="newMember" :rules="newMemberRules" ref="newMemberForm">
        <div :gutter="10">
          <el-form-item prop="firstName" label="First Name">
            <input class="input" v-model="newMember.firstName" />
          </el-form-item>
        </div>
        <div :gutter="10">
          <el-form-item prop="lastName" label="Last Name">
            <input class="input" v-model="newMember.lastName" />
          </el-form-item>
        </div>
        <div :gutter="10">
          <el-form-item prop="mobile" label="Mobile">
            <input class="input" v-model="newMember.mobile" />
          </el-form-item>
        </div>
        <div :gutter="10">
          <el-form-item prop="email" label="Email">
            <input class="input" v-model="newMember.email" />
          </el-form-item>
        </div>
        <div>
          <div class="text-right btn-container">
            <button type="success" @click.prevent="addMember" class="btn-success">Confirm</button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import generateHash from "random-hash";
import { errormsg, nonPlayerRoles, roles } from "../../utils/constants";

import { validateEmail, validatePhoneNumber } from "../../utils/utilities";

import CheckBoxLine from "../../components/CheckBoxLine.vue";

const nameSorter = (a, b) => {
  const firstNameSort = a.firstName.localeCompare(b.firstName, undefined, {
    sensitivity: "base",
  });
  const lastNameSort = a.lastName.localeCompare(b.lastName, undefined, {
    sensitivity: "base",
  });
  return firstNameSort || lastNameSort;
};

const profileNameSorter = (a, b) => {
  const firstNameSort = a.profile.firstName.localeCompare(b.profile.firstName, undefined, {
    sensitivity: "base",
  });
  const lastNameSort = a.profile.lastName.localeCompare(b.profile.lastName, undefined, {
    sensitivity: "base",
  });
  return firstNameSort || lastNameSort;
};

export default {
  name: "TrainingDetail",
  components: { CheckBoxLine },
  data() {
    return {
      confirmationdialog: false,
      addMemberDialog: false,
      showingPlayerCards: false,
      showingNonPlayerCards: false,
      showSelectPlayers: false,
      showSelectNonPlayers: false,
      isPlayerScreen: true,
      roleFilter: undefined,
      programs: [],
      positions: [],
      nonPlayerRoles,
      selectedPlayers: [],
      selectedNonPlayers: [],
      players: [],
      nonplayers: [],
      trainingRules: {
        dateTime: {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        venue: {
          validator: (rule, value, callback) =>
            this.searchVenue && this.searchVenue.length
              ? callback()
              : this.training.venue && this.training.venue.length
              ? callback()
              : callback(errormsg.input_option),
        },
        "meta.program._id": {
          required: true,
          message: errormsg.select_option,
          trigger: "blur",
        },
        "meta.sessionNo": {
          validator: (rule, value, callback) =>
            this.training.meta.sessionNo && this.training.meta.sessionNo > 0
              ? callback()
              : callback(errormsg.input_option),
        },
        // "covid.symptomsNotes": {
        //   validator: (rule, value, callback) =>
        //     this.training.covid.symptoms
        //       ? this.training.covid.symptomsNotes && this.training.covid.symptomsNotes.length
        //         ? callback()
        //         : callback(errormsg.input_option)
        //       : callback(),
        // },
        // "covid.contactNotes": {
        //   validator: (rule, value, callback) =>
        //     this.training.covid.contact
        //       ? this.training.covid.contactNotes && this.training.covid.contactNotes.length
        //         ? callback()
        //         : callback(errormsg.input_option)
        //       : callback(),
        // },
        // "travel.notes": {
        //   validator: (rule, value, callback) =>
        //     this.training.travel.has
        //       ? this.training.travel.notes && this.training.travel.notes.length
        //         ? callback()
        //         : callback(errormsg.input_option)
        //       : callback(),
        // },
      },
      newMemberRules: {
        firstName: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
        },
        lastName: {
          required: true,
          message: errormsg.input_option,
          trigger: "blur",
        },
        mobile: {
          required: false,
          message: errormsg.phone,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (value && !validatePhoneNumber(value)) {
              return callback(new Error(errormsg.phone));
            }
            return callback();
          },
        },
        email: {
          required: false,
          message: errormsg.email,
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (value && !validateEmail(value)) {
              return callback(new Error(errormsg.email));
            }
            return callback();
          },
        },
      },
      training: {
        members: [],
        manualMembers: [],
        dateTime: null,
        endTime: null,
        dateTimeStr: "",
        endTimeStr: "",
        venue: null,
        covid: {
          symptoms: false,
          symptomsNotes: "",
          contact: false,
          contactNotes: "",
        },
        travel: {
          has: false,
          notes: "",
        },
        notes: "",
        meta: {
          program: {
            _id: undefined,
            name: undefined,
          },
          sessionNo: 1,
        },
      },
      newMember: {
        firstName: undefined,
        lastName: undefined,
      },
      allVenues: [],
      searchVenue: true,
      debounce: false,
      roles,
      venues: [],
      tempDate: "",
      tempTime: "",
      dateToUpdate: 0, //timestamp
      timeToUpdate: 0, //timestamp
      trainingVenue: null,
      trainingCovidSymptoms: false,
      trainingCovidSymptomsNotes: "",
      trainingCovidContact: false,
      trainingCovidContactNotes: "",
      trainingTravelHas: false,
      trainingTravelNotes: "",
      notes: "",
      programId: undefined,
      trainingMetaProgName: undefined,
      trainingMetaSessionNo: 1,
    };
  },
  async mounted() {
    const { id } = this.$route.params;
    if (id && id !== "add") {
      this.$store.commit("root/loading", true);
      await this.$http
        .get(`nrl/api/v1/admin/training-attendances/${id}`)
        .then((res) => {
          const { dateTime, endTime } = res.data.data;

          this.$set(this, "training", Object.assign(this.training, res.data.data));
          this.trainingVenue = this.training.venue;
          this.trainingCovidSymptoms = this.training.covid.symptoms;
          this.trainingCovidSymptomsNotes = this.training.covid.symptomsNotes;
          this.trainingCovidContact = this.training.covid.contact;
          this.trainingCovidContactNotes = this.training.covid.contactNotes;
          this.trainingTravelHas = this.training.travel.has;
          this.trainingTravelNotes = this.training.travel.notes;
          this.notes = this.training.notes;
          this.programId = this.training.meta.program._id;
          this.trainingMetaProgName = this.training.meta.program.name;
          this.trainingMetaSessionNo = this.training.meta.sessionNo;

          this.$store.commit("root/loading", false);
        })
        .catch(() => {
          this.$store.commit("root/loading", false);
        });
    }

    // Program Admin
    if (this.clearance !== this.roles.programAdmin) {
      this.$http
        .get("nrl/api/v1/admin/training-attendances-members")
        .then((res) => {
          this.players = res.data.players;
          this.nonplayers = res.data.nonplayers;
        })
        .catch(() => this.$customError());
    } else if (this.training.meta.program._id) {
      const { _id } = this.training.meta.program;
      this.$http
        .get(`nrl/api/v1/admin/training-attendances-members/programs/${_id}`)
        .then((res) => {
          this.players = res.data.players;
        })
        .catch(() => this.$customError());
    }

    if (
      this.clearance === this.roles.programAdmin ||
      this.clearance === this.roles.clubProgramAdmin
    ) {
      this.$http
        .get("/nrl/api/v1/admin/programs")
        .then((res) => {
          const allPrograms = res.data.data;
          this.programs = allPrograms.filter((p) => p.isActive !== false);

          // this.programs = res.data.data;
          if (this.training.meta && this.training.meta.program && this.training.meta.program._id) {
            // Fetching program players if it's program type
            const { _id: programId } = this.training.meta.program;
            const program = this.programs.find((p) => p._id === programId);
            if (program) {
              const { name } = program;
              this.training.meta.program.name = name;
              this.$http
                .get(`nrl/api/v1/admin/training-attendances-members/programs/${programId}`)
                .then((response) => {
                  this.players = response.data.players;
                })
                .catch(() => this.$customError());
            }
          }
        })
        .catch(() => this.$customError());
    }

    // Initializing Start & End Time to prefill placeholders
    if (!this.training.dateTime || this.training.dateTime === "") {
      this.training.dateTime = this.dayjs().format();
    }

    if (!this.training.endTime || this.training.endTime === "") {
      this.training.endTime = this.dayjs().format();
    }

    this.tempDate = this.changeDateForFrontend(this.training.dateTime);
    this.tempTime = this.changeTimeForFrontend(this.training.endTime);
    this.dateToUpdate = this.dayjs(this.training.dateTime).valueOf();
    this.timeToUpdate = this.dayjs(this.training.endTime).valueOf();
  },
  methods: {
    isEdit() {
      const { id } = this.$route.params;
      return id && id !== "add";
    },
    filter(query) {
      if (query && query !== "" && query.length > 2) {
        setTimeout(() => {
          this.$http
            .post("/nrl/api/v1/admin/venues/search", { criteria: query })
            .then((response) => {
              this.allVenues = response.data.data;
            })
            .catch(() => {});
        }, 200);
      } else {
        this.allvenues = [];
      }
    },

    async suggest() {
      try {
        const query = this.trainingVenue;
        if (query == "") return;
        if (query && query !== "" && query.length <= 2) {
          this.allVenues = [];
          return;
        }
        if (this.debounce) return;

        this.debounce = true;

        const response = await this.$http.post("/nrl/api/v1/admin/venues/search", {
          criteria: query,
        });

        const allVenues = response.data.data;
        this.allVenues = allVenues.map((x) => ({ ...x, value: x.name }));
        this.debounce = false;
      } catch (e) {
        this.debounce = false;
      }
    },
    selectVenue(venue) {
      this.trainingVenue = venue.name;
      this.allVenues = [];
    },
    async addPlayers() {
      const { selectedPlayers } = this;
      const unavailable = [];
      selectedPlayers.forEach((p) => {
        const pl = this.players.find((x) => x._id === p);
        if (pl) {
          const {
            _id,
            profile: { firstName, lastName },
            available,
          } = pl;
          if (available && available.is === false) unavailable.push({ _id, firstName, lastName });
          this.training.members.push({
            type: "player",
            _id,
            firstName,
            lastName,
          });
        }
      });

      if (unavailable && unavailable.length > 0) {
        const unavailableList = unavailable.map((u) => `${u.firstName} ${u.lastName}`);
        let unavailablePlayers = "";
        const last = unavailableList.pop();
        if (unavailableList.length === 0) unavailablePlayers = last + " . ";
        else unavailablePlayers = unavailableList.join(", ") + " and " + last + " . ";
        this.$alert(`The players currently marked unavailable : ${unavailablePlayers}`);
      }
      this.showSelectPlayers = false;
    },
    async selectAllPlayers() {
      if (this.selectedPlayers.length) {
        this.selectedPlayers = [];
      } else {
        this.availablePlayersToAdd.forEach((p) => this.selectedPlayers.push(p._id));
      }
    },
    async addNonPlayers() {
      const { selectedNonPlayers } = this;
      selectedNonPlayers.forEach((p) => {
        const pl = this.nonplayers.find((x) => x._id === p);
        if (pl) {
          const {
            _id,
            profile: { firstName, lastName },
          } = pl;
          this.training.members.push({
            type: "nonplayer",
            _id,
            firstName,
            lastName,
          });
        }
      });
      this.showSelectNonPlayers = false;
    },
    async selectAllNonPlayers() {
      if (this.selectedNonPlayers.length) {
        this.selectedNonPlayers = [];
      } else {
        this.availableNonPlayersToAdd.forEach((p) => this.selectedNonPlayers.push(p._id));
      }
    },
    async addMember() {
      this.$refs.newMemberForm.validate().then((validated) => {
        if (validated) {
          const { firstName, lastName, mobile, email } = this.newMember;

          this.training.manualMembers.push({
            _id: generateHash({ length: 16 }),
            type: `${this.currentManualType || "player"}`,
            firstName,
            lastName,
            mobile,
            email,
          });
          this.newMember.firstName = null;
          this.newMember.lastName = null;
          this.newMember.mobile = null;
          this.newMember.email = null;
          this.addMemberDialog = false;
        }
      });
    },
    async submitTrainingList() {
      this.$store.commit("root/loading", true);
      this.training.venue = this.trainingVenue;
      this.training.covid.symptoms = this.trainingCovidSymptoms;
      this.training.covid.symptomsNotes = this.trainingCovidSymptomsNotes;
      this.training.covid.contact = this.trainingCovidContact;
      this.training.covid.contactNotes = this.trainingCovidContactNotes;
      this.training.travel.has = this.trainingTravelHas;
      this.training.travel.notes = this.trainingTravelNotes;
      this.training.notes = this.notes;
      if (this.programId) this.training.meta.program._id = this.programId;
      if (this.trainingMetaProgName) this.training.meta.program.name = this.trainingMetaProgName;
      this.training.meta.sessionNo = parseInt(this.trainingMetaSessionNo);

      let validated = true;
      //validate dateTime
      if (this.tempDate == "") validated = false;
      if (this.tempTime == "") validated = false;

      if (this.training.venue && this.training.venue.length <= 0) validated = false;

      if (
        this.clearance === this.roles.programAdmin &&
        this.training.meta &&
        !this.training.meta.program._id
      )
        validated = false;

      // validate meta.sessionNo
      if (this.training.meta && this.training.meta.sessionNo && this.training.meta.sessionNo < 0)
        validated = false;
      // validate covid.symptomsNotes
      // if (
      //   this.training.covid &&
      //   this.training.covid.symptoms &&
      //   this.training.covid.symptomsNotes &&
      //   this.training.covid.symptomsNotes.length <= 0
      // )
      //   validated = false;
      // // validate covid.contactNotes
      // if (
      //   this.training.covid &&
      //   this.training.covid.contact &&
      //   this.training.covid.contactNotes &&
      //   this.training.covid.contactNotes.length <= 0
      // )
      //   validated = false;
      // // validate travel.notes
      // if (
      //   this.training.travel &&
      //   this.training.travel.has &&
      //   this.training.travel.notes &&
      //   this.training.travel.notes.length <= 0
      // )
      //   validated = false;

      if (!this.isEdit()) {
        try {
          const confirmed = await this.$confirm(
            "Are you sure you want to submit this list of participants?",
            "Submit Training List"
          );

          if (validated) {
            const {
              members,
              manualMembers,

              covid,
              travel,
              notes,
              venue,
              meta,
            } = this.training;

            this.$store.commit("root/loading", true);

            const dat = { date: this.tempDate };

            const tm = { time: this.tempTime };

            const temp = this.tempDate.replace(/-/g, "/") + " " + this.tempTime;
            const dt = new Date(temp);

            const endTime = dt.getTime();
            const dateTime = endTime;

            const res = await this.$http.post("nrl/api/v1/admin/training-attendances", {
              members,
              manualMembers,
              dateTime,
              covid,
              travel,
              notes,
              venue,
              meta,
              endTime,
            });

            this.$customSuccess();
            if (res.data.data) {
              this.$router.push({
                name: "training-participants.list",
              });
            }
            this.$store.commit("root/loading", false);
            return;
          }
        } catch (e) {
          this.$store.commit("root/loading", false);
          if (e == "cancel") return;
          else this.$customError();
        }
      } else {
        try {
          const confirmed = await this.$confirm(
            "Are you sure you want to modify this list of participants?",
            "Update"
          );

          if (validated) {
            const {
              members,

              covid,
              travel,
              notes,
              venue,
              manualMembers,
              meta,
            } = this.training;

            const dat = { date: this.tempDate };

            const tm = { time: this.tempTime };

            const temp = this.tempDate.replace(/-/g, "/") + " " + this.tempTime;
            const dt = new Date(temp);

            const endTime = dt.getTime();
            const dateTime = endTime;

            await this.$http.put(`nrl/api/v1/admin/training-attendances/${this.$route.params.id}`, {
              members,
              manualMembers,
              dateTime,
              covid,
              travel,
              notes,
              venue,
              meta,
              endTime,
            });

            this.$customSuccess();
            this.$store.commit("root/loading", false);
            this.$router.push({
              name: "training-participants.list",
            });
            return;
          }
        } catch (e) {
          this.$store.commit("root/loading", false);
          if (e == "cancel") return;
          else {
            this.$customError();
          }
        }
      }
    },
    removePlayer(row, manual = false) {
      this.$confirm(
        "Are you sure you want to remove this person from the list",
        "Remove participant",
        { confirmButtonText: "OK", cancelButtonText: "Cancel" }
      )
        .then(() => {
          if (!manual) {
            this.training.members.splice(
              this.training.members.findIndex((x) => x._id === row._id),
              1
            );
          } else {
            this.training.manualMembers.splice(
              this.training.manualMembers.findIndex((x) => x._id === row._id),
              1
            );
          }
        })
        .catch(() => {});
    },
    deleteTrainingList() {
      this.$confirm("Are you sure you want to remove this list", "Delete Training List", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      }).then(() => {
        this.$http
          .delete(`nrl/api/v1/admin/training-attendances/${this.$route.params.id}`)
          .then(() => {
            this.$router.push({ name: "training-participants.list" });
          })
          .catch(() => {
            this.$customError();
          });
      });
    },
    //Time to show on frontend and send to backend
    changeTimeForFrontend(dateTimeData) {
      const dt = new Date(dateTimeData);
      const timedata = dt.toTimeString();

      return timedata.split(" ")[0];
    },
    changeTimeForBackend() {
      const dt = new Date(`${this.tempDate} ${this.tempTime}`);
      return dt.getTime();
    },

    //Date to show on frontend and send to backend
    changeDateForFrontend(timestamp) {
      const dt = new Date(timestamp);
      const months = dt.getMonth() + 1;
      const dateNumber = dt.getDate();
      if (months < 10) {
        if (dateNumber < 10) {
          return `${dt.getFullYear()}-0${months}-0${dt.getDate()}`;
        }
        return `${dt.getFullYear()}-0${months}-${dt.getDate()}`; //prefix month with "0" like 06 for date 2021-06-11
      } else {
        if (dateNumber < 10) {
          return `${dt.getFullYear()}-${months}-0${dt.getDate()}`;
        }
        return `${dt.getFullYear()}-${months}-${dt.getDate()}`; // date like 2021-12-11
      }
    },
    changeDateForBackend() {
      const dt = new Date(this.tempDate);

      return dt.valueOf();
    },
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
    availableNonPlayersToAdd() {
      const available = this.nonplayers;
      const memberType = this.roleFilter
        ? this.nonPlayerRoles.find((obj) => obj.type === this.roleFilter).memberType
        : false;
      return available
        ? available
            .filter((p) => !this.training.members.some((m) => m._id === p._id))
            .filter((p) =>
              memberType ? p.activeRegos.some((r) => r.memberType === memberType) : false
            )
            .sort(profileNameSorter)
        : [];
    },
    availablePlayersToAdd() {
      const available = this.players;

      return available
        .filter((p) => !this.training.members.some((m) => m._id === p._id))
        .sort(profileNameSorter);
    },
    trainingPlayers() {
      const { members } = this.training;
      return members.filter((member) => member.type === "player").sort(nameSorter);
    },
    trainingNonPlayers() {
      const { members } = this.training;
      return members.filter((member) => member.type === "nonplayer").sort(nameSorter);
    },
    trainingManualPlayers() {
      const { manualMembers } = this.training;
      return manualMembers.filter((member) => member.type === "player").sort(nameSorter);
    },
    trainingManualNonPlayers() {
      const { manualMembers } = this.training;
      return manualMembers.filter((member) => member.type === "nonplayer").sort(nameSorter);
    },
  },
  watch: {
    programId: {
      handler(_id) {
        if (_id) {
          const program = this.programs.find((p) => p._id === _id);
          if (program) {
            const { name } = program;
            this.training.meta.program.name = name;
            this.$http
              .get(`nrl/api/v1/admin/training-attendances-members/programs/${_id}`)
              .then((res) => {
                this.players = res.data.players;
              })
              .catch(() => this.$customError());
          }
        }
      },
      deep: true,
      immediate: true,
    },
    roleFilter() {
      this.selectedNonPlayers = [];
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-select,
.el-autocomplete,
.el-input-number {
  width: 100%;
}
.captain-icon {
  color: green;
  font-size: 2rem;
}
.remove-icon {
  color: red;
  font-size: 2rem;
}
.text-right {
  text-align: right;
}

::v-deep .el-input {
}

::v-deep .el-dialog__footer {
  text-align: center;
}
.footer-customize {
  .el-button {
    margin: 10px;
    width: 180px;
  }
}
::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase {
  display: none !important;
}

::v-deep .el-input-number .el-input__inner {
  padding: 0 !important;
  font-size: 16px; // fixed zoom-in issue on ios by increasing this font-size;
}

.btn-container {
  margin-bottom: 1rem;
}

label {
  @apply tw-text-sm  tw-font-normal tw-leading-4 tw-text-black;
}

.input {
  @apply tw-w-full tw-pl-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.select-date {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.venue-option {
  text-decoration: underline;
  font-size: 12.5px;
  margin-left: 0.5rem;
}

.additional-questions {
  font-size: 1rem;
  text-align: left;
  margin-top: 1.5rem;
}

.additional-info {
  margin-top: 0.4rem;
}

.checkbox-question {
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.endtime-picker {
  width: 100%;
}

.additional-question-cb {
  ::v-deep .el-checkbox__label {
    display: inline-block;
    width: 90%;
    height: 100%;
    white-space: pre-line;
  }
}

.modal-select {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  .el-button--secondary {
    width: 80%;
    margin-bottom: 0.5rem;
  }
  .el-button + .el-button {
    margin: 0;
    margin-bottom: 0.5rem;
  }
}

::v-deep .el-form-item__label {
  font-family: "RL2";
  font-size: 16px;
  @apply tw-text-sm  tw-font-normal tw-leading-4 tw-text-black;
}

::v-deep .vdatetime-popup__header {
  background: $nrlGreen !important;
}

::v-deep .vdatetime-popup__actions__button {
  font-weight: bold;
  color: $nrlGreen !important;
}

textarea {
  @apply tw-w-full tw-pl-2 tw-pt-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none;
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 1px;
  padding-bottom: 8px;
  @apply tw-w-full tw-px-2 tw-text-sm focus:tw-outline-none tw-placeholder-gray-800  tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none;
}

.btn-success {
  @apply tw-justify-center tw-w-full  tw-mt-6 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-white  tw-bg-green-700  tw-mb-9 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}

.btn-cancel {
  @apply tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-black  tw-bg-gray-200 tw-border-2 tw-border-green-700  hover:tw-border-gray-200 sm:tw-w-64;
}

.btn-selectAll {
  @apply tw-rounded tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-capitalize tw-text-black tw-border-2 tw-bg-gray-1000 tw-w-200 tw-h-8;
}

.search {
  background-image: url("../../assets/searchInBlack.svg"); /* Add custom search */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 23px 40px;
  background-position-y: 1px;

  @apply tw-w-full tw-col-start-1 tw-pb-2 tw-col-end-12 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-shadow-none focus:tw-outline-none;
}

.playerOnly {
  display: flex;
  justify-content: center;
}

.player-list {
  height: 100%;
  overflow: hidden;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .el-button + .el-button {
    margin: 0;
    margin-bottom: 0.5rem;
  }

  .el-button--primary {
    background: transparent;
    color: black;
    margin: 1rem;
  }

  .custom-select {
    margin: 1.5rem;
  }
  .add-players {
    margin: 1rem;
    margin-bottom: 1.75rem;
  }
  .player-list-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
  }

  .list-group {
    width: 80%;
    max-height: 24rem;
    overflow: scroll;
    overflow-x: hidden;
    padding-inline-start: 0;
    margin-bottom: 2rem;
    .list-group-item {
      list-style-type: none;
      border-bottom: 1px solid #ddd;
      input {
        display: none;
      }

      label {
        padding-top: 1rem;
        padding-bottom: 1rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        word-break: break-word;
        width: 100%;
      }

      .el-row {
        display: flex;
        align-items: center;
        .el-col {
          display: flex;
        }
      }
    }
  }
}
</style>
